module.exports = __webpack_public_path__ + "img/civil_case_part_1_splash.b4128f5d.jpg";